import type { Author, NewsArticle } from '@/types/news';

const newsroom: Author = {
  id: 'autor-redaccion',
  name: 'Redacción El Divergente',
  bio: 'Equipo periodístico de Puerto San Julián.'
};

const opinionAuthor: Author = {
  id: 'autor-opinion',
  name: 'Mesa de Opinión',
  bio: 'Voces invitadas y análisis editorial de la región.'
};

export const seedNews: NewsArticle[] = [
  {
    id: 'news-001',
    slug: 'puerto-san-julian-activa-operativo-preventivo-en-la-costanera',
    title: 'Puerto San Julián activa un operativo preventivo en la costanera',
    summary:
      'Equipos municipales y fuerzas locales coordinan recorridas nocturnas durante el fin de semana.',
    body:
      'El operativo suma presencia preventiva, asistencia a vecinos y control de circulación en puntos de alta concurrencia. La medida prioriza la convivencia urbana y el cuidado de familias que utilizan la costanera durante la tarde y la noche.\n\nLa coordinación incluye recorridas a pie, controles de tránsito y comunicación directa con comercios cercanos. Desde el municipio remarcaron que el esquema se ajustará según movimiento turístico, clima y actividades programadas.\n\nLa recomendación para vecinos es circular con documentación, respetar zonas de estacionamiento y dar aviso temprano ante situaciones de riesgo.',
    category: 'Sociedad',
    author: newsroom,
    tags: ['costanera', 'prevención', 'municipio'],
    place: 'Puerto San Julián',
    people: ['Municipalidad de Puerto San Julián'],
    hero: {
      id: 'media-001',
      type: 'image',
      url: 'https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=1400&q=82',
      alt: 'Vista costera al atardecer',
      width: 1400,
      height: 1800
    },
    gallery: [
      {
        id: 'media-001-gallery-1',
        type: 'image',
        url: 'https://images.unsplash.com/photo-1500534314209-a25ddb2bd429?auto=format&fit=crop&w=1200&q=82',
        alt: 'Camino costero con cielo patagónico',
        width: 1200,
        height: 900
      }
    ],
    seoTitle: 'Operativo preventivo en la costanera de Puerto San Julián',
    metaDescription:
      'Puerto San Julián refuerza controles y recorridas preventivas en la costanera durante el fin de semana.',
    metaKeywords: ['Puerto San Julián', 'costanera', 'prevención', 'Santa Cruz'],
    status: 'published',
    featured: true,
    breaking: false,
    views: 1480,
    readingTimeMinutes: 3,
    publishedAt: '2026-08-04T20:45:00.000Z',
    updatedAt: '2026-08-04T20:45:00.000Z'
  },
  {
    id: 'news-002',
    slug: 'clubes-locales-preparan-una-agenda-deportiva-para-agosto',
    title: 'Clubes locales preparan una agenda deportiva intensa para agosto',
    summary: 'Fútbol, atletismo y actividades recreativas suman fechas para jóvenes y familias.',
    body:
      'Las instituciones deportivas de la ciudad confirmaron encuentros, entrenamientos abiertos y torneos de integración. La agenda busca sostener la participación juvenil y ampliar el uso de espacios comunitarios.\n\nLos clubes trabajan con categorías infantiles, juveniles y mayores. También habrá actividades recreativas para familias que acompañan los torneos barriales.\n\nLa programación se publicará por etapas para ordenar traslados, disponibilidad de gimnasios y presencia de equipos de salud.',
    category: 'Deportes',
    author: newsroom,
    tags: ['deportes', 'clubes', 'agenda'],
    place: 'Puerto San Julián',
    people: ['Clubes locales'],
    hero: {
      id: 'media-002',
      type: 'image',
      url: 'https://images.unsplash.com/photo-1526232761682-d26e03ac148e?auto=format&fit=crop&w=1400&q=82',
      alt: 'Cancha deportiva iluminada',
      width: 1400,
      height: 1800
    },
    gallery: [],
    seoTitle: 'Agenda deportiva de agosto en Puerto San Julián',
    metaDescription:
      'Clubes de Puerto San Julián preparan torneos, entrenamientos abiertos y actividades deportivas para agosto.',
    metaKeywords: ['deportes', 'clubes', 'Puerto San Julián', 'agenda'],
    status: 'published',
    featured: false,
    breaking: false,
    views: 940,
    readingTimeMinutes: 3,
    publishedAt: '2026-08-04T17:15:00.000Z',
    updatedAt: '2026-08-04T17:15:00.000Z'
  },
  {
    id: 'news-003',
    slug: 'salud-refuerza-la-campana-de-vacunacion-de-invierno',
    title: 'Salud refuerza la campaña de vacunación de invierno',
    summary: 'El hospital local amplió horarios de consulta para grupos priorizados.',
    body:
      'La campaña sanitaria continúa con atención por demanda y turnos programados. Los equipos recomiendan completar esquemas, especialmente en adultos mayores, personal esencial y personas con factores de riesgo.\n\nLa atención se organiza por franjas horarias para reducir esperas y priorizar a pacientes con mayor exposición. También se reforzó la comunicación en centros comunitarios.\n\nDesde Salud recordaron asistir con libreta sanitaria y consultar ante síntomas respiratorios persistentes.',
    category: 'Salud',
    author: newsroom,
    tags: ['salud', 'vacunación', 'invierno'],
    place: 'Puerto San Julián',
    people: ['Hospital local'],
    hero: {
      id: 'media-003',
      type: 'image',
      url: 'https://images.unsplash.com/photo-1584515933487-779824d29309?auto=format&fit=crop&w=1400&q=82',
      alt: 'Personal de salud preparando insumos',
      width: 1400,
      height: 1800
    },
    gallery: [],
    seoTitle: 'Campaña de vacunación de invierno en Puerto San Julián',
    metaDescription:
      'Salud amplía la atención para vacunación de invierno en Puerto San Julián y prioriza grupos de riesgo.',
    metaKeywords: ['salud', 'vacunación', 'invierno', 'hospital'],
    status: 'published',
    featured: false,
    breaking: true,
    views: 2160,
    readingTimeMinutes: 3,
    publishedAt: '2026-08-04T14:05:00.000Z',
    updatedAt: '2026-08-04T14:05:00.000Z'
  },
  {
    id: 'news-004',
    slug: 'concejo-analiza-proyecto-para-ordenar-el-transito-en-zonas-escolares',
    title: 'El Concejo analiza un proyecto para ordenar el tránsito en zonas escolares',
    summary: 'La iniciativa propone señalización, reducción de velocidad y controles en horarios pico.',
    body:
      'El proyecto ingresó con foco en accesos escolares, cruces de mayor circulación y horarios de entrada y salida. La propuesta apunta a reducir maniobras riesgosas y mejorar el ordenamiento diario.\n\nEntre los puntos en estudio aparecen señalización horizontal, espacios delimitados para ascenso y descenso, y campañas de concientización con familias.\n\nLa discusión continuará en comisión con aportes de equipos directivos y áreas técnicas municipales.',
    category: 'Política',
    author: newsroom,
    tags: ['concejo', 'tránsito', 'escuelas'],
    place: 'Puerto San Julián',
    people: ['Concejo Deliberante'],
    hero: {
      id: 'media-004',
      type: 'image',
      url: 'https://images.unsplash.com/photo-1494526585095-c41746248156?auto=format&fit=crop&w=1400&q=82',
      alt: 'Calle urbana con edificios bajos',
      width: 1400,
      height: 1800
    },
    gallery: [],
    seoTitle: 'Proyecto para ordenar el tránsito escolar en Puerto San Julián',
    metaDescription:
      'El Concejo analiza medidas de señalización y controles para mejorar el tránsito en zonas escolares.',
    metaKeywords: ['política', 'concejo', 'tránsito escolar', 'educación'],
    status: 'published',
    featured: true,
    breaking: false,
    views: 1320,
    readingTimeMinutes: 3,
    publishedAt: '2026-08-04T11:30:00.000Z',
    updatedAt: '2026-08-04T11:30:00.000Z'
  },
  {
    id: 'news-005',
    slug: 'comercios-locales-registran-mas-movimiento-por-la-agenda-de-invierno',
    title: 'Comercios locales registran más movimiento por la agenda de invierno',
    summary: 'Gastronomía, indumentaria y servicios turísticos notan una mejora en la circulación.',
    body:
      'Comerciantes del centro y sectores cercanos a la costanera marcaron un repunte asociado a actividades culturales, deportivas y movimiento de visitantes. La mejora aparece especialmente durante tardes y fines de semana.\n\nEl consumo se concentra en gastronomía, abrigo, accesorios y servicios de paso. Los negocios sostienen promociones breves para acompañar el flujo de clientes.\n\nLa expectativa del sector es mantener una agenda coordinada que ayude a distribuir mejor la actividad durante agosto.',
    category: 'Economía',
    author: newsroom,
    tags: ['comercio', 'economía local', 'turismo'],
    place: 'Puerto San Julián',
    people: ['Comerciantes locales'],
    hero: {
      id: 'media-005',
      type: 'image',
      url: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?auto=format&fit=crop&w=1400&q=82',
      alt: 'Local gastronómico con mesas preparadas',
      width: 1400,
      height: 1800
    },
    gallery: [],
    seoTitle: 'Comercios de Puerto San Julián registran más movimiento',
    metaDescription:
      'La agenda de invierno impulsa la circulación en comercios, gastronomía y servicios locales.',
    metaKeywords: ['economía', 'comercio local', 'turismo', 'Puerto San Julián'],
    status: 'published',
    featured: false,
    breaking: false,
    views: 760,
    readingTimeMinutes: 3,
    publishedAt: '2026-08-03T22:10:00.000Z',
    updatedAt: '2026-08-03T22:10:00.000Z'
  },
  {
    id: 'news-006',
    slug: 'escuelas-preparan-muestras-y-actividades-por-la-semana-sanmartiniana',
    title: 'Escuelas preparan muestras y actividades por la semana sanmartiniana',
    summary: 'Instituciones educativas organizan trabajos especiales, actos y recorridos históricos.',
    body:
      'Docentes y estudiantes trabajan en muestras sobre historia argentina, producción artística y actividades de lectura. La agenda se distribuirá entre actos escolares y espacios abiertos para familias.\n\nLa propuesta busca conectar contenidos curriculares con identidad local, memoria y participación comunitaria. Algunas instituciones sumarán recorridos por puntos históricos de la ciudad.\n\nLos equipos directivos informarán horarios definitivos durante la semana para ordenar la participación de cada comunidad educativa.',
    category: 'Educación',
    author: newsroom,
    tags: ['escuelas', 'educación', 'historia'],
    place: 'Puerto San Julián',
    people: ['Escuelas locales'],
    hero: {
      id: 'media-006',
      type: 'image',
      url: 'https://images.unsplash.com/photo-1509062522246-3755977927d7?auto=format&fit=crop&w=1400&q=82',
      alt: 'Aula escolar con estudiantes',
      width: 1400,
      height: 1800
    },
    gallery: [],
    seoTitle: 'Escuelas de Puerto San Julián preparan actividades sanmartinianas',
    metaDescription:
      'Instituciones educativas organizan muestras, actos y recorridos por la semana sanmartiniana.',
    metaKeywords: ['educación', 'escuelas', 'San Martín', 'Puerto San Julián'],
    status: 'published',
    featured: false,
    breaking: false,
    views: 690,
    readingTimeMinutes: 3,
    publishedAt: '2026-08-03T18:20:00.000Z',
    updatedAt: '2026-08-03T18:20:00.000Z'
  },
  {
    id: 'news-007',
    slug: 'agenda-cultural-suma-musica-teatro-y-feria-de-emprendedores',
    title: 'La agenda cultural suma música, teatro y feria de emprendedores',
    summary: 'Espacios comunitarios tendrán propuestas para públicos diversos durante el fin de semana.',
    body:
      'La programación cultural reúne presentaciones musicales, teatro independiente y una feria de emprendedores con productos regionales. Las actividades se repartirán entre espacios cerrados y puntos de circulación barrial.\n\nLa organización apunta a sostener propuestas accesibles y fortalecer la presencia de artistas locales. También habrá puestos gastronómicos y espacios para infancias.\n\nLos horarios fueron pensados para evitar superposiciones con actividades deportivas y facilitar la asistencia familiar.',
    category: 'Cultura',
    author: newsroom,
    tags: ['cultura', 'teatro', 'emprendedores'],
    place: 'Puerto San Julián',
    people: ['Artistas locales', 'Emprendedores'],
    hero: {
      id: 'media-007',
      type: 'image',
      url: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?auto=format&fit=crop&w=1400&q=82',
      alt: 'Escenario con músicos en vivo',
      width: 1400,
      height: 1800
    },
    gallery: [
      {
        id: 'media-007-gallery-1',
        type: 'image',
        url: 'https://images.unsplash.com/photo-1511795409834-ef04bbd61622?auto=format&fit=crop&w=1200&q=82',
        alt: 'Feria con luces cálidas y puestos',
        width: 1200,
        height: 900
      }
    ],
    seoTitle: 'Agenda cultural con música, teatro y feria en Puerto San Julián',
    metaDescription:
      'La agenda cultural local suma música, teatro, feria de emprendedores y propuestas familiares.',
    metaKeywords: ['cultura', 'música', 'teatro', 'emprendedores'],
    status: 'published',
    featured: true,
    breaking: false,
    views: 1210,
    readingTimeMinutes: 3,
    publishedAt: '2026-08-03T15:45:00.000Z',
    updatedAt: '2026-08-03T15:45:00.000Z'
  },
  {
    id: 'news-008',
    slug: 'vecinos-reclaman-mejor-iluminacion-en-un-sector-barrial',
    title: 'Vecinos reclaman mejor iluminación en un sector barrial',
    summary: 'El pedido apunta a mejorar circulación nocturna y seguridad peatonal.',
    body:
      'Familias de un sector barrial solicitaron mantenimiento y ampliación de luminarias en calles de circulación cotidiana. El planteo se centra en paradas, esquinas y accesos utilizados por estudiantes y trabajadores.\n\nEl reclamo fue elevado con registro fotográfico y detalle de puntos críticos. Vecinos aseguran que la falta de luz modifica rutinas y reduce el uso de espacios públicos por la noche.\n\nEl área correspondiente recibió el pedido y evaluará el estado del tendido antes de definir prioridades de intervención.',
    category: 'Policiales',
    author: newsroom,
    tags: ['seguridad', 'iluminación', 'barrios'],
    place: 'Puerto San Julián',
    people: ['Vecinos'],
    hero: {
      id: 'media-008',
      type: 'image',
      url: 'https://images.unsplash.com/photo-1519501025264-65ba15a82390?auto=format&fit=crop&w=1400&q=82',
      alt: 'Calle urbana de noche con luces',
      width: 1400,
      height: 1800
    },
    gallery: [],
    seoTitle: 'Vecinos piden mejor iluminación en un barrio de Puerto San Julián',
    metaDescription:
      'Vecinos solicitan mantenimiento de luminarias para mejorar circulación nocturna y seguridad peatonal.',
    metaKeywords: ['policiales', 'seguridad', 'iluminación', 'barrios'],
    status: 'published',
    featured: false,
    breaking: false,
    views: 1110,
    readingTimeMinutes: 3,
    publishedAt: '2026-08-03T12:00:00.000Z',
    updatedAt: '2026-08-03T12:00:00.000Z'
  },
  {
    id: 'news-009',
    slug: 'conectividad-y-tramites-digitales-el-desafio-que-crece-en-la-region',
    title: 'Conectividad y trámites digitales: el desafío que crece en la región',
    summary: 'Vecinos y comercios dependen cada vez más de servicios online para gestiones diarias.',
    body:
      'La digitalización de trámites, pagos y turnos modificó la vida cotidiana en la región. La conectividad aparece como una condición clave para trabajar, estudiar y resolver gestiones sin trasladarse.\n\nComercios y profesionales locales incorporan herramientas de cobro, reservas y comunicación directa con clientes. Al mismo tiempo, persisten diferencias de acceso según zona, edad y disponibilidad de dispositivos.\n\nLa discusión pública empieza a moverse hacia infraestructura, alfabetización digital y acompañamiento para personas que necesitan asistencia en trámites online.',
    category: 'Tecnología',
    author: newsroom,
    tags: ['conectividad', 'trámites digitales', 'tecnología'],
    place: 'Puerto San Julián',
    people: ['Vecinos', 'Comercios'],
    hero: {
      id: 'media-009',
      type: 'image',
      url: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=1400&q=82',
      alt: 'Persona usando una computadora portátil',
      width: 1400,
      height: 1800
    },
    gallery: [],
    seoTitle: 'Conectividad y trámites digitales en Puerto San Julián',
    metaDescription:
      'La dependencia de servicios online crece y abre desafíos de conectividad, infraestructura y alfabetización digital.',
    metaKeywords: ['tecnología', 'conectividad', 'trámites digitales', 'Santa Cruz'],
    status: 'published',
    featured: false,
    breaking: false,
    views: 530,
    readingTimeMinutes: 4,
    publishedAt: '2026-08-02T21:10:00.000Z',
    updatedAt: '2026-08-02T21:10:00.000Z'
  },
  {
    id: 'news-010',
    slug: 'la-ciudad-que-discute-su-ritmo-entre-crecimiento-y-cuidado',
    title: 'La ciudad que discute su ritmo entre crecimiento y cuidado',
    summary: 'Una mirada sobre los cambios urbanos, la convivencia y el valor de decidir con tiempo.',
    body:
      'Puerto San Julián atraviesa conversaciones que se repiten en muchas ciudades intermedias: cómo crecer, cómo ordenar la circulación y cómo cuidar los espacios que todavía sostienen vida comunitaria.\n\nLa discusión no se resuelve con nostalgia ni con velocidad pura. Requiere datos, escucha y una idea compartida de ciudad que permita tomar decisiones antes de que los problemas se vuelvan urgencias.\n\nMirar el ritmo urbano también implica reconocer a quienes trabajan, estudian, cuidan y se mueven todos los días. La planificación empieza cuando esas rutinas entran en la conversación pública.',
    category: 'Opinión',
    author: opinionAuthor,
    tags: ['opinión', 'ciudad', 'convivencia'],
    place: 'Puerto San Julián',
    people: ['Comunidad local'],
    hero: {
      id: 'media-010',
      type: 'image',
      url: 'https://images.unsplash.com/photo-1494522855154-9297ac14b55f?auto=format&fit=crop&w=1400&q=82',
      alt: 'Ciudad pequeña vista desde una calle tranquila',
      width: 1400,
      height: 1800
    },
    gallery: [],
    seoTitle: 'Opinión: crecimiento urbano y cuidado comunitario',
    metaDescription:
      'Una lectura editorial sobre el crecimiento, la convivencia y la planificación urbana en Puerto San Julián.',
    metaKeywords: ['opinión', 'ciudad', 'planificación', 'Puerto San Julián'],
    status: 'published',
    featured: false,
    breaking: false,
    views: 880,
    readingTimeMinutes: 4,
    publishedAt: '2026-08-02T17:40:00.000Z',
    updatedAt: '2026-08-02T17:40:00.000Z'
  },
  {
    id: 'news-011',
    slug: 'nuevas-medidas-internacionales-impactan-en-costos-de-transporte',
    title: 'Nuevas medidas internacionales impactan en costos de transporte',
    summary: 'Cambios logísticos externos empiezan a sentirse en cadenas de abastecimiento regionales.',
    body:
      'Las modificaciones en costos logísticos internacionales tienen efecto indirecto sobre insumos, traslados y tiempos de entrega. En ciudades alejadas de grandes centros de distribución, esos movimientos suelen sentirse con mayor demora y mayor impacto.\n\nReferentes del sector comercial siguen de cerca la evolución de combustibles, fletes y disponibilidad de mercadería importada. El principal temor es que la presión de costos afecte reposición de productos específicos.\n\nLa recomendación para comercios es planificar compras, revisar proveedores y evitar decisiones apresuradas frente a variaciones temporales.',
    category: 'Internacionales',
    author: newsroom,
    tags: ['internacionales', 'transporte', 'logística'],
    place: 'Santa Cruz',
    people: ['Sector comercial'],
    hero: {
      id: 'media-011',
      type: 'image',
      url: 'https://images.unsplash.com/photo-1494412519320-aa613dfb7738?auto=format&fit=crop&w=1400&q=82',
      alt: 'Camiones circulando en ruta',
      width: 1400,
      height: 1800
    },
    gallery: [],
    seoTitle: 'Medidas internacionales y costos de transporte regional',
    metaDescription:
      'Cambios logísticos internacionales generan impacto en costos de transporte y abastecimiento regional.',
    metaKeywords: ['internacionales', 'transporte', 'logística', 'abastecimiento'],
    status: 'published',
    featured: false,
    breaking: false,
    views: 420,
    readingTimeMinutes: 3,
    publishedAt: '2026-08-02T13:25:00.000Z',
    updatedAt: '2026-08-02T13:25:00.000Z'
  }
];
